import React from 'react'

import ScreenViewFilterBar from '../../../../containers/screenViews/ScreenViewFilterBar'
import UserFiltersList from '../../../../containers/users/filters/UserFiltersList'

const FiltersBar = ({ open }) => {
  return (
    <ScreenViewFilterBar screen="users" open={open}>
      <UserFiltersList />
    </ScreenViewFilterBar>
  )
}

export default FiltersBar
